/**
 * 首页相关
 */
import http from "@/utils/axiosoUtil";
import router from "@/router";
import { Dialog } from "vant";
import PHDialog from "@components/PhDialog";

const mutations = {
  setState(state, payload) {
    state.bannerList = payload.bannerList;
    state.functionList = payload.functionList;
    state.newsList = payload.newsList;
  },
  setHospitalInfo(state, payload) {
    state.hospitalInfo = payload;
  },
  setHospitalConfig(state, payload) {
    state.hospitalConfig = payload;
  }
};

const actions = {
  initData({ commit }) {
    http.get(http.api.HOME).then(res => {
      commit("setState", {
        bannerList: res.bannerList,
        functionList: res.functionList,
        newsList: res.newsList
      });
    });
  },
  // getHospitalInfo({ state, commit }) {
  //   if (!state.hospitalInfo) {
  //     http.post(http.api.REFERENCE_HOSPITAL_INFO).then(res => {
  //       commit("setHospitalInfo", res);
  //     });
  //   }
  // },
  getHospitalConfig({ state, commit }) {
    return new Promise(resolve => {
      if (!state.hospitalConfig) {
        http
          .configPost(http.api.HOSPITAL_CONFIG, {
            url: location.origin + location.pathname
          })
          .then(res => {
            commit("setHospitalConfig", res);
            resolve(res);
          });
      } else {
        resolve(state.hospitalConfig);
      }
    });
  },
  // 首页功能跳转
  routeNavigate({ dispatch }, item) {
    if (!item.url) {
      router.push({ name: "404" });
      return;
    }
    if (item.linkType === "3") {
      location.href = item.url;
      return;
    }
    if (item.linkType === "4") {
      dispatch("users/getUserBaseQrcodeInfo", null, { root: true }).then(() => {
        dispatch("pathRouter", {
          ...item,
          qrtype: "2"
        });
      });
      return;
    }
    if (item.isNeedCard === "1") {
      dispatch(
        "users/getUserBaseInfo",
        item.functionType == "3" ? "1" : item.functionType,
        { root: true }
      )
        .then(res => {
          if (
            item.url === "recharge" &&
            item.functionType === "2" &&
            res.inpatientState === "2"
          ) {
            alert("您已经出院或未办理完入院手续，请勿充值");
            return;
          }
          dispatch("pathRouter", item);
        })
        .catch(error => {
          const notQRCode = error.errorCode == "502";
          PHDialog.confirm({
            message: error.message,
            closeOnClickOverlay: notQRCode,
            confirmButtonText: notQRCode ? "手动添加" : "确认",
            cancelButtonText: notQRCode ? "领用多码融合码" : "取消"
          })
            .then(() => {
              router.push({
                name: "relative-card",
                query: {
                  ftype: item.functionType
                }
              });
            })
            .catch(() => {
              if (notQRCode) {
                http.route("/ecode", "1");
              }
            });
        });
      return;
    } else {
      dispatch("pathRouter", item);
    }
  },
  pathRouter(_, item) {
    if (item.linkType === "2") {
      http.route(item.url, item.functionType);
      return;
    }
    if (item.linkType === "5") {
      http
        .post(http.api.INPATIENT_SETTLEMENT_CONFIRM, {
          functionType: item.functionType
        })
        .then(() => {
          http.route(item.url, "1");
        })
        .catch(error => {
          if (error.errorCode === "502") {
            PHDialog.confirm({
              message: error.message,
              closeOnClickOverlay: true,
              confirmButtonText: "手动添加",
              cancelButtonText: "领用多码融合码"
            })
              .then(() => {
                router.push({
                  name: "relative-card",
                  query: {
                    ftype: item.functionType
                  }
                });
              })
              .catch(() => {
                http.route("/ecode", "1");
              });
          } else {
            Dialog.alert({
              message: error.message
            });
          }
        });
      return;
    }
    var query = { ftype: item.functionType };
    var { url, qrtype } = item;
    if (url === "satisfaction-outpatient") {
      query.quesType = "02";
    } else if (url === "satisfaction-outpatient-out") {
      url = "satisfaction-outpatient";
      query.quesType = "03";
    } else if (url === "appointment-schedule-department") {
      query = {
        ftype: 1,
        id: "1071",
        type: "department"
      };
    }
    if (!qrtype) {
      qrtype = "1";
    }
    router.push({
      name: url.replace("/", ""),
      query: {
        ...query,
        qrtype
      }
    });
  }
};

const state = {
  hospitalInfo: null,
  bannerList: [],
  functionList: [],
  newsList: [],
  hospitalConfig: null
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
